<template>
  <woot-button
    variant="smooth"
    class="concurrent--add"
    icon="add"
    size="tiny"
    @click="addConcurrent"
  >
    {{ $t('CONTACT_PANEL.CONCURRENTS.CONVERSATION.ADD_BUTTON') }}
  </woot-button>
</template>

<script>
export default {
  methods: {
    addConcurrent() {
      this.$emit('add');
    },
  },
};
</script>

<style lang="scss" scoped>
.concurrent--add {
  margin-bottom: var(--space-micro);
  margin-right: var(--space-micro);
}
</style>

